<template>
    <div>
        <!-- 面包屑导航区域 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <!-- <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item> -->
            <el-breadcrumb-item>{{$t('i18n.fota_update')}}</el-breadcrumb-item>
            <el-breadcrumb-item>{{$t('i18n.version_mange')}}</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="app-container">
            <el-card class="filter-container"  shadow="never">
                <el-select  v-model="queryInfo.designName"  :placeholder="$t('i18n.choose_design')"  :filterable="true"  clearable  @change="handleSelectionChange" >
                       <el-option  v-for="item in designCompanyList"  :key="item.value"  :label="item.label"  :value="item.label"></el-option>
                </el-select>

                <el-select style="padding-left:10px"  v-model="queryInfo.brandName"    :placeholder="$t('i18n.choose_brand')"    :filterable="true"    clearable  @change="handleSelectionChange">
                        <el-option v-for="item in brandList" :key="item.value" :label="item.label" :value="item.label" ></el-option>
                </el-select>

                <el-select style="padding-left:10px"  v-model="queryInfo.projectName"  :placeholder="$t('i18n.choose_project')"  :filterable="true"  clearable  @change="handleSelectionChange">
                    <el-option    v-for="item in projectlist"    :key="item.value"    :label="item.label"    :value="item.label" ></el-option>
                </el-select>
                <span style="padding-left:20px">
                    <el-col :span="3">
                          <el-input :placeholder="$t('i18n.column.like_search')" v-model="queryInfo.keywords" @keyup.enter.native="likeSearch"  clearable @clear="likeSearch">
                              <el-button slot="append" icon="el-icon-search" @click="likeSearch"></el-button>
                          </el-input>
                    </el-col>
                    <el-button  type="primary" round  @click="handleResetSearch()"  size="mini">{{$t('i18n.reset')}}</el-button>
                    <!-- <el-button  @click="getVersionList()"  type="primary" round  size="mini">查询</el-button> -->
                    <el-button  type="primary" round  class="btn-add"  @click="handleAddVersion()"  size="mini">{{$t('i18n.add_version')}}</el-button>
                </span>
            </el-card>

            <!-- 添加项目的对话框 -->
            <el-dialog
                title="添加项目"
                :visible.sync="addDialogVisible"
                width="50%"
                @close="addDialogClosed"
            >
                <!-- 内容主体区域 -->
                <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="70px">
                    <el-form-item :label="$t('i18n.column.design')" prop="designId">
                        <el-select
                            v-model="addForm.designId"
                            :placeholder="$t('i18n.choose_design')"
                            filterable
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in designCompanyList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('i18n.column.brand')" prop="brandId">
                        <el-select
                            v-model="addForm.brandId"
                            :placeholder="$t('i18n.choose_brand')"
                            filterable
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in brandList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="OEM" prop="oem">
                        <el-input v-model="addForm.oem" :placeholder="$t('i18n.column.oem')"></el-input>
                    </el-form-item>
                    <el-form-item label="PRODUCT" prop="productName">
                        <el-input v-model="addForm.productName" :placeholder="$t('i18n.column.product_name')" s></el-input>
                    </el-form-item>
                    <el-form-item label="LANGUAGE" prop="language">
                        <el-select
                            v-model="addForm.language"
                            :placeholder="$t('i18n.column.language')"
                            filterable
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in languages"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="OPERATOR" prop="operator">
                        <el-select
                            v-model="addForm.operator"
                            :placeholder="$t('i18n.column.operator')"
                            filterable
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in operators"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <!-- 底部区域 -->
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">{{ $t('i18n.cancel')}}</el-button>
                    <el-button type="primary" @click="addRroject">{{ $t('i18n.confirm')}}</el-button>
                </span>
            </el-dialog>
        </div>

        <div class="table-container">
            <!-- table表格区域 -->
            <el-table :data="versionList" border stripe>
                <!-- <el-table-column type="index"></el-table-column> -->
                <el-table-column :label="$t('i18n.column.version_id')" width="80px" prop="versionId"></el-table-column>
                <el-table-column :label="$t('i18n.column.design')" prop="designName" width="120px"  ></el-table-column>
                <el-table-column :label="$t('i18n.column.brand')" prop="brandName" width="120px" ></el-table-column>
                <el-table-column :label="$t('i18n.column.project')" prop="projectName" width="340px"></el-table-column>
                <el-table-column :label="$t('i18n.column.create_time')" prop="createTime"></el-table-column>
                <el-table-column :label="$t('i18n.column.versionNo')" prop="versionNo"></el-table-column>
                <el-table-column :label="$t('i18n.column.version_status')" prop="status" width="400px" ></el-table-column>
                <el-table-column :label="$t('i18n.column.memo')" prop="memo"></el-table-column>
                <el-table-column :label="$t('i18n.column.operator')" width="260px">
                    <template slot-scope="scope">
                        <el-button type="danger" circle icon="el-icon-delete"  size="mini" @click="handleDeleteVersion(scope.row)">

                        </el-button>
                        <el-button  type="info" round  icon="el-icon-setting" :disabled="computeStatus(scope.row.status)"  size="mini"  @click="handleBeforeVersion(scope.row)">{{ $t('i18n.settings') }}</el-button>
                        <el-button
                            type="warning" round
                            icon="el-icon-edit"
                            size="mini"
                            @click="handleEditVersion(scope.row)"
                        >{{ $t('i18n.update')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="paginnation-container">
            <!-- 分页区域 -->
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryInfo.pageNo"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize"
                background
            ></el-pagination>
        </div>
    </div>
</template>

<script>
import { deleteVersion } from '@/api/version';
const defaultListQuery = {
    versionId: null,
    brandName: '',
    productName: '',
    keywords: '',
    designName: '',
    projectName: '',
    pageNo: 1,
    pageSize: 15
};

export default {
    inject:['reload'],//注入reload方法刷新页面
    data() {
        return {
            // 查询参数对象
            // 项目列表
            projectlist: [],
            versionList: [],
            // 总数据条数
            totalSize: 0,
            brandList: [],
            designCompanyList: [],
            queryInfo: Object.assign({}, defaultListQuery),
            // 控制添加项目对话框的显示与隐藏
            addDialogVisible: false,
            // 添加项目的表单数据
            addForm: {
                designId: '',
                brandId: '',
                oem: '',
                language: '',
                operator: '',
                productName: ''
            },
            operators: [
                {
                    value: 'other',
                    label: 'other'
                },
                {
                    value: 'CMCC',
                    label: 'CMCC'
                },
                {
                    value: 'CU',
                    label: 'CU'
                },
                {
                    value: 'BIOS',
                    label: 'BIOS'
                },
                {
                    value: 'EC',
                    label: 'EC'
                }
            ],
            languages: [
                {
                    value: 'zh-CN',
                    label: '中文'
                },
                {
                    value: 'en-US',
                    label: '英文'
                },
                {
                    value: 'ja-JP',
                    label: '日语'
                }
            ],
            // 添加表单的验证规则对象
            addFormRules: {
                designId: [{ required: true, message: this.$t('i18n.validate.design_need'), trigger: 'blur' }],
                brandId: [{ required: true, message: this.$t('i18n.validate.brand_need'), trigger: 'blur' }],
                productName: [{ required: true, message: this.$t('i18n.validate.product_name_need'), trigger: 'blur' }],
                oem: [{ required: true, message: this.$t('i18n.validate.oem'), trigger: 'blur' }],
                language: [{ required: true, message: this.$t('i18n.validate.language_need'), trigger: 'blur' }],
                operator: [{ required: true, message: this.$t('i18n.validate.operator_need'), trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getProjectList();
        this.getBrandList();
        this.getDesignCompanyList();
        this.getVersionList();
    },
    methods: {
       async getVersionList() {
           const { data: res } =await  this.$http.get('/version/queryVersionPage', {
                    params: this.queryInfo
                })
                 if (res.code !== 0) {
                    return this.$message.error(res.msg);
                 }
                this.versionList = res.data.list;
                this.totalSize = res.data.totalSize;
        },

        async likeSearch() {
            this.queryInfo.pageNo=1
           const { data: res } =await  this.$http.get('/version/queryVersionPage', {
                    params: this.queryInfo
                })
                 if (res.code !== 0) {
                    return this.$message.error(res.msg);
                 }
                this.versionList = res.data.list;
                this.totalSize = res.data.totalSize;
        },

        // 根据分页获取对应的项目列表
       async getProjectList() {
                const { data: res } =await this.$http.get('/project/queryAll', {
                })
                if (res.code !== 0) {
                    return this.$message.error(res.msg);
                }
                this.projectlist = [];
                let projectlist = res.data;
                for (let i = 0; i < projectlist.length; i++) {
                    this.projectlist.push({ label: projectlist[i].projectName, value: projectlist[i].id });
                }
       },
      async  getBrandList() {
            const { data: res } =await this.$http.get('/brand/queryPage', {
                    params: this.queryInfo
            })
            if (res.code !== 0) {
                 return this.$message.error(res.msg);
            }
            this.brandList = [];
            let brandList = res.data.list;
            for (let i = 0; i < brandList.length; i++) {
                this.brandList.push({ label: brandList[i].brandName, value: brandList[i].id });
            }
        },

          async getDesignCompanyList() {
           const { data: res } = await this.$http.get('/designCompany/queryPage', {
                    params: this.queryInfo
            })
            if (res.code !== 0) {
                return this.$message.error(res.msg);
            }
            this.designCompanyList = [];
            let designCompanyList = res.data.list;
            for (let i = 0; i < designCompanyList.length; i++) {
                this.designCompanyList.push({ label: designCompanyList[i].designName, value: designCompanyList[i].id });
            }
        },
        handleSelectionChange(){
            this.getVersionList()
        },

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getVersionList();
        },
        handleCurrentChange(newPage) {
            this.queryInfo.pageNo = newPage;
            this.getVersionList();
        },
        async handleDeleteVersion(row) {
            console.log('----当前版本行------', row);
            const confirmResult = await this.$confirm(this.$t('i18n.is_delete_continue'), this.$t('i18n.tip'), {
                confirmButtonText: this.$t('i18n.confirm'),
                cancelButtonText: this.$t('i18n.cancel'),
                type: 'warning'
            }).catch(err => {
                console.log(this.$t('i18n.fail'), err);
                return err;
            });

            if (confirmResult !== 'confirm') {
                return this.$message.info(this.$t('i18n.had_cancel_delete'));
            }
            console.log('版本id', row.versionId);
            const { data: res } = await deleteVersion(row.versionId);
            if (res.code !== 0) {
                return this.$message.error(res.msg);
            }
            this.getVersionList();
            this.$message.success(this.$t('i18n.success'));
            
        },

        projectCreate() {
            this.$router.push('/project/create');
        },
       
        // 重置
        handleResetSearch() {
            this.queryInfo = Object.assign({}, defaultListQuery);
            this.getVersionList();
        },

        // 监听添加项目对话框的关闭事件
        addDialogClosed() {
            this.$refs.addFormRef.resetFields();
        },
        // 点击按钮，添加新项目
        addRroject() {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return;
                // 可以发起添加项目的网络请求
                const { data: res } = await this.$http.post('/project/create', this.addForm);
                if (res.code !== 0) {
                    this.$message.error(res.msg);
                }
                // 隐藏添加项目的对话框
                this.addDialogVisible = false;
                // 重新获取项目列表数据
                this.getProjectList();
            });
        },
        handleAddVersion(){
          this.$router.push({path:'/versionAdd'})
        },
        handleBeforeVersion(param) {
            this.$router.push({path:'/versionDetail',
            query:{
                updateVersionNo:param.versionNo,
                updateVersionId:param.versionId,
                projectName:param.projectName

            }
            
            });
        },
           handleEditVersion(row) {
            this.$router.push({path:'/versionUpdate',query:{versionId:row.versionId}});
        },
        computeStatus(status){
        if(status=='初始版本'){
            return true
        }
        return false;
    },
    },
  
};
</script>

<style  scoped>
    .el-pagination {
         text-align: right; 
    }
    /* .paginnation-container {
    position: fixed;
    
     left: 40%;
     bottom: 0%;
}
.filter-container{
    height:65px;
    padding:0cm;
} */

</style>
